/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useState } from "react";
import TableActions from "../../Helpers/Table/TableActions";
import { useGetAllDevicesQuery } from "../../../Redux/service/Devices";
import TableRow from "../../Helpers/Table/TableRow";
import { filtrationcontext } from "../../../context/Filtercontext";
import { formatDate } from "../../../JsHelpers/DateFormat";
import Empty from "../../Helpers/Empty/Empty";
import { toast } from "react-toastify";
import trans from "../../../utils";
import { useGetAllGroupsQuery } from "../../../Redux/service/Groups/Groups";

export default function VehiclesTableBody({ data }) {
	const [TableData, setTableData] = useState([]);
	const { VehiclessearchQuery, setTotalPages, vehicleArchived } =
		useContext(filtrationcontext);
	const { data: UniqueData, refetch: refetchDevices } = useGetAllDevicesQuery();
	const { data: allGroups } = useGetAllGroupsQuery();
	const [activeViewId, setActiveViewId] = useState(null);
	const handleView = (id) => {
		setActiveViewId((prev) => (prev === id ? null : id));
	};

	useEffect(() => {
		refetchDevices();
	}, [data, refetchDevices]);

	useEffect(() => {
		setTableData(data);
		setTotalPages(data?.totalPages);
	}, [VehiclessearchQuery, data, setTotalPages]);

	if (data?.length === 0)
		return (
			<Empty
				title={trans("No Vehicles Found")}
				subtitle={trans("Create your new vehicle now!")}
			/>
		);
	if (!TableData) {
		toast.error(trans("No Data Found, Please reload"), {
			autoClose: 800,
			rtl: localStorage.getItem("lang") === "ar" ? true : false,
		});
		return null;
	}

	return (
		<>
			{(vehicleArchived === "All vehicles"
				? TableData
				: TableData?.filter((j) =>
						vehicleArchived === "Archived"
							? j.archived === true
							: j.archived === false
				  )
			)?.map((i) => {
				const { formattedDate, formattedTime } = formatDate(i.lastUpdate);
				const checkExpire = () => {
					const expireTime = new Date(i.licenseExpire).getTime();
					if (!i.licenseExpire || expireTime === 0 || isNaN(expireTime))
						return "N/A";

					const now = Date.now();
					const tenDays = 10 * 24 * 60 * 60 * 1000;
					const diff = expireTime - now;
					const daysRemaining = Math.ceil(diff / (1000 * 60 * 60 * 24));

					if (diff <= 0) {
						return trans("Expired");
					} else if (diff <= tenDays) {
						return `${daysRemaining} ${trans("days left")}`;
					} else {
						return trans("Valid");
					}
				};

				const getStatusKey = () => {
					const expireTime = new Date(i.licenseExpire).getTime();
					if (!i.licenseExpire || expireTime === 0 || isNaN(expireTime))
						return "NA";

					const now = Date.now();
					const tenDays = 10 * 24 * 60 * 60 * 1000;
					const diff = expireTime - now;

					if (diff <= 0) return "Expired";
					if (diff <= tenDays) return "Soon";
					return "Valid";
				};

				const getStyle = () => {
					const status = getStatusKey();

					switch (status) {
						case "Valid":
							return ["table-element-success", "table-bg-element-success"];
						case "Soon":
							return ["table-element-soon", "table-bg-element-soon"];
						case "Expired":
							return ["table-element-fail", "table-bg-element-fail"];
						default:
							return ["", ""];
					}
				};

				return (
					<div key={i.id} className="table-row">
						<TableRow value={i.name} style="table-element-name ps-0" />
						<TableRow value={i.plateNumber} />
						<TableRow
							value={checkExpire()}
							style={getStyle()[0]}
							valuestyle={getStyle()[1]}
						/>
						<TableRow value={i.imei} />
						<TableRow
							value={
								i.lastUpdate === null
									? "N/A"
									: formattedDate + " " + formattedTime
							}
						/>
						<TableRow
							value={i.archived === false ? trans("Active") : trans("Archived")}
							style={
								i.archived === false
									? "table-element-active fw-500"
									: "table-element-archived fw-500"
							}
							valuestyle={
								i.archived === false
									? "table-bg-element-active fw-500"
									: "table-bg-element-archived fw-500"
							}
						/>
						<TableRow
							value={allGroups?.find((g) => g.id === i.groupId)?.name || "N/A"}
						/>
						<TableRow
							value={i?.vehicle_user?.length || "N/A"}
							view={{
								status: true,
								type: "vehicles",
								id: i.id,
								data: i?.vehicle_user,
								name: i?.name,
							}}
							activeViewId={activeViewId}
							setActiveViewId={setActiveViewId}
						/>
						{/* Use parentName directly */}
						<TableActions
							vehicleId={i.id}
							vehicleuniqueId={
								UniqueData?.find((j) => j.uniqueId === i.imei)?.id
							}
							name={i.name}
							type="link"
						/>
					</div>
				);
			})}
		</>
	);
}
